import { useState, useEffect, useContext, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";
import ContextProduct from "../../context/contextproduct/ContextProduct";
import ThemeToggle from "./ThemeToggle";
import CartDropDown from "./CartDropDown";

const NavBar = () => {
  const { cart } = useContext(ContextProduct);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const count = cart.reduce((qty, item) => item.quantity + qty, 0);

  // border appears once the page is scrolled
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // close the mini-cart on outside click / Escape
  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const linkClass = ({ isActive }) => `nav__link ${isActive ? "active" : ""}`;

  return (
    <nav className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__brand">
          MER<span>CANTILE</span>
        </Link>

        <div className="nav__links">
          <NavLink to="/" end className={linkClass}>
            Home
          </NavLink>
          <NavLink to="/products" className={linkClass}>
            Products
          </NavLink>
        </div>

        <div className="nav__right">
          <ThemeToggle />

          <div className="cart-btn-wrap" ref={wrapRef}>
            <button
              type="button"
              className="cart-btn"
              onClick={() => setOpen((o) => !o)}
              aria-haspopup="true"
              aria-expanded={open}
            >
              <FiShoppingBag size={18} />
              <span className="cart-btn__count">{count}</span>
            </button>

            {open && <CartDropDown onClose={() => setOpen(false)} />}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
